import { Assignment, AssignmentEndOfCare, AssignmentWithRelations } from '../api/app-types/assignment';
import { CLARIFICATION_TYPE } from '../api/app-types/relative.app';
import { mockDocuments } from './document-file.mock';

export const mockAssignments: Assignment[] = [
	{
		id: 1,
		clientId: 1,
		typeOfCareId: 1,
		sponsorId: 1,
		legalFoundationId: 1,
		caseGroupId: 1,
		initiatorId: 1,
		careRelatedHandicapId: 1,
		contacts: [
			{
				id: 1,
				anonym: false,
				confidential: false,
				contactedAt: new Date(),
				contactType: {
					id: 1,
					initial: 'Phone',
				},
				keyword: 'Test',
				participants: [
					{
						item: {
							id: 1,
							personTypeId: 1,
							firstName: 'Max',
							name: 'Mustermann',
							personId: '1',
						},
						personTypeId: 1,
						contactPoints: [],
					},
				],
				remark: 'This is a test contact',
				documents: mockDocuments,
				tasks: [],
				isFrozen: false,
				editableForDays: 42,
			},
		],
		otherText: 'Some other text',
		phase: {
			id: 1,
			remark: 'P1',
		},
		phaseId: 1,
		phaseStart: new Date().toISOString(),
		socialDataProtectionInfo: true,
		hasBeenClarified: false,
		isRestricted: false,
	},
];

export const mockAssignmentWithRelations: AssignmentWithRelations = {
	id: 1,
	clientId: 123,
	typeOfCareId: 1,
	sponsorId: 1,
	legalFoundationId: 1,
	caseGroupId: 1,
	initiatorId: 1,
	careRelatedHandicapId: 1,
	contacts: [
		{
			id: 1,
			anonym: false,
			confidential: false,
			contactedAt: new Date('2024-10-01'),
			contactType: {
				id: 1,
				initial: 'Phone',
			},
			keyword: 'Test',
			participants: [
				{
					item: {
						id: 1,
						personTypeId: 1,
						firstName: 'Max',
						name: 'Mustermann',
						personId: '1',
					},
					personTypeId: 1,
					contactPoints: [],
				},
			],
			remark: 'This is a test contact',
			documents: mockDocuments,
			tasks: [],
			isFrozen: false,
			editableForDays: 42,
		},
	],
	otherText: 'Some other text',
	phase: {
		id: 3,
		remark: 'P2',
	},
	phaseId: 3,
	phaseStart: new Date('2024-09-01').toISOString(),
	socialDataProtectionInfo: true,
	hasBeenClarified: true,
	clarifiedAt: new Date('2024-09-01'),
	typeOfClarification: CLARIFICATION_TYPE.IN_PERSON,
	contactStart: new Date('2024-09-01'),
	unemployabilitySince: new Date('2024-08-01'),
	typeOfCare: {
		id: 1,
		remark: 'Pflegegrad 1',
		integrationOfficeId: 1,
		initial: 'P1',
	},
	sponsor: {
		id: 1,
		name: 'Sponsor 1',
		integrationOfficeId: 1,
	},
	legalFoundation: {
		description: 'Mock Legal Foundation 1',
		id: 1,
		integrationOfficeId: 1,
		sponsorId: 1,
	},
	caseGroup: {
		id: 1,
		description: 'Gruppe A',
	},
	careRelatedHandicap: {
		id: 1,
		disabilityType: {
			id: 1,
			remark: 'Type A',
			categoryDiagnoses: [],
		},
		categoryDiagnosis: {
			id: 1,
			description: 'Description A',
		},
		statusAsOf: new Date(),
		documents: [],
		clientId: 123,
		advisor: {
			firstName: 'Advisor',
			lastName: 'One',
			email: 'advisor.one@example.com',
			id: '1',
			displayName: 'Advisor One',
			isActive: true,
			objectId: '1',
		},
	},
	isRestricted: false,
	guid: 'assignment-number-1',
};

export const mockAssignmentWithRelationsPhase4: AssignmentWithRelations = {
	...mockAssignmentWithRelations,
	id: 2,
	phaseId: 4,
	phase: {
		id: 4,
		remark: 'P4',
	},
	phaseChangeId: 1,
};

export const mockEndOfCares: AssignmentEndOfCare[] = [
	{
		id: 1,
		designation: 'End of Care 1',
		activityEnforcedStatus: 0,
		initials: 'EOC1',
	},
	{
		id: 2,
		designation: 'End of Care 2',
		activityEnforcedStatus: 1,
		initials: 'EOC2',
	},
];
